import ApiClient from "./apiClient";

const permissionsService = {
  getUserPermissions: (userId: string | number) =>
    ApiClient.get("permissionsset/user_permissions", {
      params: { id: userId },
    }),
  saveUserPermissions: (payload: Record<string, any>) =>
    ApiClient.post("permissionsset/save_user_permissions", payload),
  getGroupPermissions: (groupId: string | number) =>
    ApiClient.get("permissionsset/group_permissions", {
      params: { id: groupId },
    }),
  saveGroupPermissions: (payload: Record<string, any>) =>
    ApiClient.post("permissionsset/save_group_permissions", payload),
  getRolePermissions: (roleId: string | number) =>
    ApiClient.get("permissionsset/role_permissions", {
      params: { id: roleId },
    }),
  saveRolePermissions: (payload: Record<string, any>) =>
    ApiClient.post("permissionsset/save_role_permissions", payload),
};

export default permissionsService;
